module.exports = __webpack_public_path__ + "assets/retina_TrapezoidCut3Detailed.c7a3e9093509086ed8e3bd981071cde1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TrapezoidCut3Detailed.png
// module id = 745
// module chunks = 0